<template>
    <div></div>
</template>
<script>
export default{
    components:{
    },
    data(){
        return{
            //登入系統API
            apiBackendLogin: (data) =>
                this.userRequest.post("bicd/BackendLogin", data),
        };
    },  
    mounted(){
        //初始化
        this.init();   
    },
    watch:{
    },
    methods:{
        //初始化
        init() {
            let json = {
                TYPE: "LOGOUT",
                login_SELECT: {},
            }
            this.FunctionToken(this.functionLogOut, json);
        },
        //登入&登出操作
        functionLogOut(data) {
            this.apiBackendLogin(data)
                .then((res) => {
                    const json = JSON.parse(res.data);
                    if (json.Status) {
                        //登出後返回登入介面
                        this._go("/ISY");
                    }
            })
            .catch((err) => {
            console.log(err);
            });
        }
    },
};
</script>